import {
  IonImg
} from '@ionic/react'
import React from "react"
import styles from './styles.module.scss'
import {siteUrl} from "../../../../app/settings"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCirclePlay} from "@fortawesome/free-solid-svg-icons"

export const MediaBox = ({
                           post,
                           onClick,
                         }) => {

  const getImageUrl = (uri) => {
    return siteUrl() + uri
  }

  return(
    <div className={styles.media_box_container}>

      <IonImg src={getImageUrl(post.cover_picture)} onClick={() => onClick(post)} />

      { parseInt(post.cover_picture_is_video) === 1 &&
        <div className={styles.video_indicator} onClick={() => onClick(post)}>
          <FontAwesomeIcon icon={faCirclePlay} />
        </div>
      }

      {post.media_count > 1 &&
        <div className={styles.media_count} onClick={() => onClick(post)}>
          <h1>+{post.media_count - 1}</h1>
        </div>
      }
    </div>
  )

}